import { graphql } from '@/gql';
import type { FetchPartnerBudgetQuery } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export type FetchPartnerBudgetOutput = FetchPartnerBudgetQuery['partnerBudget'];

export const fetchPartnerBudget = async (codeName: string): Promise<FetchPartnerBudgetOutput> => {
  const response = await queryExecute({
    query: graphql(`
      query FetchPartnerBudget($codeName: String!) {
        partnerBudget(codeName: $codeName) {
          partnerId
          currency
          budget
          spend
          remaining
          percentUsed
          startDate
          endDate
        }
      }
    `),
    variables: {
      codeName,
    },
    // figures must be current as of opening the overview
    fetchPolicy: 'no-cache',
  });

  return response.data.partnerBudget;
};
